import EInvoiceDetailDisable from './EInvoiceDetailDisable.vue'

export default EInvoiceDetailDisable